import { render } from "./TarotDetailFooterForWeb.vue?vue&type=template&id=beff8ed6&scoped=true"
import script from "./TarotDetailFooterForWeb.vue?vue&type=script&lang=js"
export * from "./TarotDetailFooterForWeb.vue?vue&type=script&lang=js"

import "./TarotDetailFooterForWeb.vue?vue&type=style&index=0&id=beff8ed6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beff8ed6"]])

export default __exports__